import { PriceDisplay } from "./PriceDisplay";

// 健診コース行コンポーネント（リスト形式）
export const PlanRow = ({
  label,
  description,
  selfPayAmount,
  counterPayAmount,
  businessBurdenAmount,
}: {
  label: string;
  description: string;
  selfPayAmount: number;
  counterPayAmount: number;
  businessBurdenAmount?: number;
}) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
    <div className="flex-1">
      <h3 className="text-base font-bold text-primary-6">{label}</h3>
      <p className="mt-1 text-sm text-monotone-7">{description}</p>
    </div>
    <div className="flex flex-col items-end gap-1">
      <PriceDisplay
        counterPayAmount={counterPayAmount}
        selfPayAmount={selfPayAmount}
      />
      {businessBurdenAmount != null && businessBurdenAmount > 0 && (
        <p className="text-xs text-monotone-6">
          ※事業所負担分{businessBurdenAmount.toLocaleString()}円
        </p>
      )}
    </div>
  </div>
);
